/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Storefront_Build_CtaInputs */

const en_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Your Storefront`)
};

const es_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza tu tienda`)
};

const fr_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer votre vitrine`)
};

const de_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Storefront starten`)
};

const ja_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを立ち上げる`)
};

const zh_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动您的店铺`)
};

const ar_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق واجهة متجرك`)
};

const id_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan Etalase Anda`)
};

const it_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia la Tua Vetrina`)
};

const ru_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустить витрину`)
};

const pt_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançar a sua Vitrine`)
};

const ko_seller_storefront_build_cta = /** @type {(inputs: Seller_Storefront_Build_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 런칭하기`)
};

/**
* | output |
* | --- |
* | "Launch Your Storefront" |
*
* @param {Seller_Storefront_Build_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_storefront_build_cta = /** @type {((inputs?: Seller_Storefront_Build_CtaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Storefront_Build_CtaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_storefront_build_cta(inputs)
	if (locale === "es") return es_seller_storefront_build_cta(inputs)
	if (locale === "fr") return fr_seller_storefront_build_cta(inputs)
	if (locale === "de") return de_seller_storefront_build_cta(inputs)
	if (locale === "ja") return ja_seller_storefront_build_cta(inputs)
	if (locale === "zh") return zh_seller_storefront_build_cta(inputs)
	if (locale === "ar") return ar_seller_storefront_build_cta(inputs)
	if (locale === "id") return id_seller_storefront_build_cta(inputs)
	if (locale === "it") return it_seller_storefront_build_cta(inputs)
	if (locale === "ru") return ru_seller_storefront_build_cta(inputs)
	if (locale === "pt") return pt_seller_storefront_build_cta(inputs)
	return ko_seller_storefront_build_cta(inputs)
});